import React from 'react';

import config from 'configs/app';
import useAddChainClick from 'lib/web3/useAddChainClick';
import useProvider from 'lib/web3/useProvider';

interface Props {
  className?: string;
  label?: React.ReactNode;
}

/** "Add NirmalX Testnet" for visitors with a browser wallet; renders nothing without one. */
const AddToWallet = ({ className, label }: Props) => {
  const { provider, wallet } = useProvider();
  const handleClick = useAddChainClick();

  if (!provider || !wallet || !config.chain.rpcUrls.length || !config.features.web3Wallet.isEnabled) {
    return null;
  }

  return (
    <button type="button" className={ className } onClick={ handleClick }>
      { label ?? `Add ${ config.chain.name }` }
    </button>
  );
};

export default React.memo(AddToWallet);
